'use client'
import { findWalletBookWallet } from '@dynamic-labs/wallet-book';
import { InjectedWalletBase } from './InjectedWalletBase.js';

class UnknownInjected extends InjectedWalletBase {
    constructor(opts) {
        super(opts);
        this.name = 'Unknown';
        this.overrideKey = 'unknown';
        this.wallet = findWalletBookWallet(this.walletBook, this.key);
    }
    isInstalledOnBrowser() {
        return false;
    }
}

export { UnknownInjected };
